<template>
	<b-modal
		ref="tournament-annual-report-modal"
		title="REPORTE ANUAL"
		no-close-on-backdrop
		@hidden="handleHidden"
		size="xmd"
		hide-footer
		scrollable
	>
		<div class="font-weight-bolder text-primary my-1">RESULTADOS POR AÑO</div>
		<VueApexCharts type="bar" height="400" :options="resultBarOpts" :series="resultBarData" />
		<div class="font-weight-bolder text-primary my-1">EFECTIVIDAD POR AÑO</div>
		<VueApexCharts type="line" height="400" :options="efiChartOpts" :series="efiChartData" />
		<div class="font-weight-bolder text-primary my-1">GASTOS POR AÑO</div>
		<VueApexCharts type="bar" height="400" :options="expenseBarOpts" :series="expenseBarData" />
	</b-modal>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import TournamentDashboardService from "@/services/tournament/default.service.js"
export default {
	components: { VueApexCharts },
	props: {},
	data() {
		return {
			efiChartOpts: {
				labels: [
					"Enero",
					"Febrero",
					"Marzo",
					"Abril",
					"Mayo",
					"Junio",
					"Julio",
					"Agosto",
					"Septiembre",
					"Octubre",
					"Noviembre",
					"Diciembre",
				],
				colors: ["#33d491", "#ecdc4d", "#ff4d4d"],
				legend: { position: "bottom", fontWeight: 600, labels: { colors: "#82868b" } },
			},
			efiChartData: [{ name: "Triunfo", data: new Array(12).fill(10) }],
			resultBarOpts: {
				labels: [],
				colors: ["#33d491", "#ecdc4d", "#ff4d4d"],
				legend: { position: "bottom", fontWeight: 600, labels: { colors: "#82868b" } },
			},
			resultBarData: [
				{
					name: "Triunfo",
					data: new Array(12).fill(10),
				},
				{
					name: "Empate",
					data: new Array(12).fill(20),
				},
				{
					name: "Derrota",
					data: new Array(12).fill(30),
				},
			],
			expenseBarOpts: {
				labels: [
					"Enero",
					"Febrero",
					"Marzo",
					"Abril",
					"Mayo",
					"Junio",
					"Julio",
					"Agosto",
					"Septiembre",
					"Octubre",
					"Noviembre",
					"Diciembre",
				],
				colors: ["#33d491", "#ecdc4d", "#ff4d4d", "#6258cc", "#5148a8", "#3f3984", "#2e2960", "#0b0a18"],
				legend: { position: "bottom", fontWeight: 600, labels: { colors: "#82868b" } },
			},
			expenseBarData: [
				{
					name: "Gastos",
					data: new Array(12).fill(10),
				},
			],
		}
	},
	methods: {
		async getAnnualReport() {
			try {
				const { data } = await TournamentDashboardService.getAnnualReport()
				const { expenses, results } = data
				this.resultBarOpts = {
					labels: results.map((item) => item.year),
					colors: ["#33d491", "#ecdc4d", "#ff4d4d"],
					legend: { position: "bottom", fontWeight: 600, labels: { colors: "#82868b" } },
					plotOptions: {
						bar: {
							dataLabels: {
								position: "top",
							},
						},
					},
					dataLabels: {
						enabled: true,
						formatter: (val, opts) => {
							const idx = opts.dataPointIndex
							const serie = opts.seriesIndex
							const item = results[idx]
							let value = val
							let percent = ""
							if (serie === 0) percent = `${item.triunfos_percentage}%`
							if (serie === 1) percent = `${item.empates_percentage}%`
							if (serie === 2) percent = `${item.derrotas_percentage}%`
							return `${value} (${percent})`
						},
						style: {
							fontSize: "13px",
							fontWeight: "bold",
							colors: ["#000000", "#000000", "#000000"],
						},
						offsetY: -20,
					},
					tooltip: {
						y: {
							formatter: (val, opts) => {
								const idx = opts.dataPointIndex
								const serie = opts.seriesIndex
								const item = results[idx]
								let percent = ""
								if (serie === 0) percent = `${item.triunfos_percentage}%`
								if (serie === 1) percent = `${item.empates_percentage}%`
								if (serie === 2) percent = `${item.derrotas_percentage}%`
								return `${val} (${percent})`
							},
						},
					},
				}
				this.resultBarData = [
					{
						name: "Triunfo",
						data: results.map((item) => item.triunfos),
					},
					{
						name: "Empate",
						data: results.map((item) => item.empates),
					},
					{
						name: "Derrota",
						data: results.map((item) => item.derrotas),
					},
				]
				this.efiChartOpts = {
					labels: results.map((item) => item.year),
					colors: ["#33d491"],
					tooltip: {
						y: {
							formatter: (val) => `${val}%`,
						},
					},
					yaxis: {
						labels: {
							formatter: (val) => `${val}%`,
						},
					},
				}
				this.efiChartData = [
					{
						name: "Efectividad",
						data: results.map((item) => item.effectivity),
					},
				]
				this.expenseBarOpts = {
					labels: expenses.map((item) => item.year),
					colors: ["#ff4d4d"],
					legend: { position: "bottom", fontWeight: 600, labels: { colors: "#82868b" } },
					yaxis: {
						labels: {
							formatter: (val) =>
								`S/. ${val >= 1000 ? (val / 1000).toFixed(1).replace(".0", "") + "k" : val}`,
						},
					},
					tooltip: {
						y: {
							formatter: (val) =>
								`S/. ${val >= 1000 ? (val / 1000).toFixed(1).replace(".0", "") + "k" : val}`,
						},
					},
					dataLabels: {
						enabled: true,
						formatter: (val) =>
							`S/. ${val >= 1000 ? (val / 1000).toFixed(1).replace(".0", "") + "k" : val}`,
					},
				}
				this.expenseBarData = [
					{
						name: "Gastos",
						data: expenses.map((item) => item.total),
					},
				]
			} catch (error) {
				console.error("Error fetching annual report data:", error)
			}
		},
		handleHidden() {
			this.$emit("closeModal")
		},
	},
	async mounted() {
		await this.getAnnualReport()
		this.$refs["tournament-annual-report-modal"].toggle()
	},
}
</script>

<style></style>
